// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Search,
//   MapPin,
//   Building2,
//   Globe,
//   X,
//   MapPinned,
//   BriefcaseIcon,
//   ArrowUpRight,
//   Filter,
// } from "lucide-react";
// import Navbar from "./shared/Navbar";
// import Footer from "./Footer";
// import TopCompanies from "./TopCompanies";
// import { COMPANY_API_END_POINT } from "@/utils/constant";

// // Card component for displaying company information
// const CompanyCard = ({ company, onViewJobs }) => {
//   return (
//     <div className="bg-white rounded-xl sm:rounded-2xl border border-[#979696] hover:shadow-lg overflow-hidden flex flex-col justify-between h-full">
//       {/* Content Section */}
//       <div className="p-4 sm:p-6 space-y-3 sm:space-y-4">
//         <div className="flex items-start justify-between gap-3 sm:gap-4">
//           {/* Logo */}
//           <div className="flex items-start gap-3 sm:gap-4 min-w-0">
//             <div className="h-16 w-16 sm:h-20 sm:w-20 md:h-24 md:w-24 shrink-0 rounded-lg sm:rounded-xl flex items-center justify-center p-1.5 sm:p-2 bg-gray-50">
//               {company.logo ? (
//                 <img
//                   src={company.logo}
//                   alt={`${company.CompanyName} logo`}
//                   className="w-full h-full object-contain"
//                 />
//               ) : (
//                 <Building2 className="w-6 h-6 sm:w-8 sm:h-8 text-gray-400" />
//               )}
//             </div>
//           </div>

//           {/* Job Count Badge */}
//           {company.jobCount > 0 && (
//             <span className="mt-2 sm:mt-3 shrink-0 px-2.5 sm:px-3 py-0.5 sm:py-1 bg-[#DFECFF] text-[#292929] text-xs sm:text-sm font-medium rounded-lg whitespace-nowrap">
//               {company.jobCount} {company.jobCount === 1 ? "Job posted" : "Jobs posted"}
//             </span>
//           )}
//         </div>

//         {/* Company Name and Location */}
//         <div className="min-w-0 ml-2">
//           <h3 className="text-lg sm:text-xl font-semibold text-gray-900 hover:text-blue-600 transition-colors truncate">
//             {company.CompanyName}
//           </h3>
//           <div className="flex items-center text-gray-600 mt-1">
//             <MapPin className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1 shrink-0" />
//             <span className="text-xs sm:text-sm truncate">{company.location}</span>
//           </div>
//         </div>

//         {/* Description */}
//         <p className="text-gray-600 text-xs sm:text-sm line-clamp-2">
//           {company.description}
//         </p>
//       </div>

//       {/* Action Footer */}
//       <div className="mt-auto px-4 sm:px-6 pb-3 sm:pb-4 flex justify-end">
//         <button
//           onClick={() => onViewJobs(company.companyId)}
//           className="w-full sm:w-40 py-2 sm:py-2.5 px-3 bg-white border-2 border-[#012760] text-[#012760] rounded-lg font-medium
//                    hover:bg-[#012760] hover:text-white transition-all duration-300
//                    focus:ring-2 focus:ring-[#012760] focus:ring-offset-2
//                    flex items-center justify-center gap-2 text-sm sm:text-base"
//         >
//           <span>View Details</span>
//         </button>
//       </div>
//     </div>
//   );
// };


// // Filter section component
// const FilterSection = ({ filters, setFilters, showFilters }) => {
//   if (!showFilters) return null;

//   return (
//     <div className="mt-4 flex flex-col sm:flex-row gap-3 sm:gap-4 max-w-4xl mx-auto">
//       <div className="relative flex-1 min-w-0">
//         <MapPinned className="absolute left-3 sm:left-4 top-3 sm:top-3.5 w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
//         <input
//           type="text"
//           placeholder="Filter by location"
//           className="w-full pl-10 sm:pl-12 pr-3 sm:pr-4 py-2.5 sm:py-3.5 border-2 rounded-lg sm:rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm sm:text-base"
//           value={filters.location}
//           onChange={(e) => setFilters({ ...filters, location: e.target.value })}
//         />
//       </div>

//       <button
//         className={`px-4 sm:px-6 py-2.5 sm:py-3.5 border-2 rounded-lg sm:rounded-xl font-medium transition-all duration-300 min-w-[140px] sm:min-w-[160px] text-sm sm:text-base ${
//           filters.isHiring
//             ? "bg-blue-600 border-blue-600 text-white hover:bg-blue-700"
//             : "bg-white hover:bg-gray-50"
//         }`}
//         onClick={() =>
//           setFilters((prev) => ({ ...prev, isHiring: !prev.isHiring }))
//         }
//       >
//         Currently Hiring
//       </button>
//     </div>
//   );
// };

// // Main component
// const Company = () => {
//   const navigate = useNavigate();
//   const [companies, setCompanies] = useState([]);
//   const [filteredCompanies, setFilteredCompanies] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//   const [showFilters, setShowFilters] = useState(false);
//   const [filters, setFilters] = useState({
//     location: "",
//     search: "",
//     isHiring: false,
//   });

//   // Fetch companies on mount
//   useEffect(() => {
//     fetchCompanies();
//   }, []);

//   // Filter companies when filters or companies change
//   useEffect(() => {
//     filterCompanies();
//   }, [companies, filters]);

//   // Fetch companies from API
//   const fetchCompanies = async () => {
//     try {
//       const response = await fetch(
//         `${COMPANY_API_END_POINT}/companyinfo`
//       );
//       const data = await response.json();
//       if (data.status) {
//         setCompanies(data.companies);
//         setFilteredCompanies(data.companies);
//       }
//     } catch (error) {
//       console.error("Error fetching companies:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Filter companies based on search criteria
//   const filterCompanies = () => {
//     let filtered = [...companies];

//     if (filters.search) {
//       const searchTerm = filters.search.toLowerCase();
//       filtered = filtered.filter(
//         (company) =>
//           company.CompanyName.toLowerCase().includes(searchTerm) ||
//           company.description?.toLowerCase().includes(searchTerm)
//       );
//     }

//     if (filters.location) {
//       filtered = filtered.filter((company) =>
//         company.location.toLowerCase().includes(filters.location.toLowerCase())
//       );
//     }

//     if (filters.isHiring) {
//       filtered = filtered.filter((company) => company.jobCount > 0);
//     }

//     setFilteredCompanies(filtered);
//   };

//   // Reset all filters
//   const resetFilters = () => {
//     setFilters({
//       location: "",
//       search: "",
//       isHiring: false,
//     });
//   };

//   // Handle navigation to jobs page
//   const handleViewJobs = (companyId) => {
//     navigate(`/jobs/${companyId}`);
//   };

//   // Render loading skeleton
//   const renderLoadingSkeleton = () => (
//     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//       {[...Array(6)].map((_, i) => (
//         <div key={i} className="animate-pulse">
//           <div className="h-72 bg-gray-100 rounded-2xl"></div>
//         </div>
//       ))}
//     </div>
//   );

//   // Render empty state
//   const renderEmptyState = () => (
//     <div className="col-span-3 text-center py-16">
//       <div className="mx-auto w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center mb-4">
//         <Building2 className="w-12 h-12 text-gray-400" />
//       </div>
//       <h3 className="text-xl font-semibold text-gray-900 mb-2">
//         No companies found
//       </h3>
//       <p className="text-gray-600">Try adjusting your search criteria</p>
//     </div>
//   );

//   return (
//     <div className="min-h-screen ">
//       <Navbar />
//       <div className="mx-auto mt-20 sm:mt-20">
//         <div className="mx-auto">
//           {/* Header Section */}
//           <div className="px-4 sm:px-8 md:px-36 py-6 sm:py-8 md:py-12 bg-[#DFECFF] w-full">
//             <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-left text-[#012760] mb-4 sm:mb-6 md:mb-10">
//               Join your dream team.
//             </h1>
//             {/* Search and Filter Controls */}
//             <div className="flex flex-col lg:flex-row gap-3 sm:gap-4 max-w-3xl mx-auto lg:ml-0">
//               <div className="flex-1 relative">
//                 <Search className="absolute left-3 sm:left-4 top-3 sm:top-3.5 w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
//                 <input
//                   type="text"
//                   placeholder="Search companies or descriptions..."
//                   className="w-full pl-10 sm:pl-12 pr-3 sm:pr-4 py-2.5 sm:py-3.5 border-2 rounded-lg sm:rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-gray-900 text-sm sm:text-base"
//                   value={filters.search}
//                   onChange={(e) =>
//                     setFilters({ ...filters, search: e.target.value })
//                   }
//                 />
//               </div>

//               <div className="flex items-center gap-2 sm:gap-3">
//                 <button
//                   onClick={() => setShowFilters(!showFilters)}
//                   className="px-3 sm:px-4 py-2.5 sm:py-3.5 border-2 rounded-lg sm:rounded-xl font-medium bg-[#012760] flex items-center gap-1.5 sm:gap-2 text-sm sm:text-base"
//                 >
//                   <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
//                   <span className="text-white">Filters</span>
//                 </button>

//                 {(filters.search || filters.location || filters.isHiring) && (
//                   <button
//                     onClick={resetFilters}
//                     className="px-3 sm:px-4 py-2.5 sm:py-3.5 text-gray-700 hover:text-gray-900 flex items-center gap-1.5 sm:gap-2 text-sm sm:text-base"
//                   >
//                     <X className="w-4 h-4 sm:w-5 sm:h-5" />
//                     <span>Clear</span>
//                   </button>
//                 )}
//               </div>
//             </div>

//             {/* Filter Section */}
//             <FilterSection
//               filters={filters}
//               setFilters={setFilters}
//               showFilters={showFilters}
//             />
//           </div>

//           <div>
//             <TopCompanies />
//           </div>
//           <div className="bg-gray-300 h-px w-full"></div>

//           {/* Content Section */}
//           <div className="p-4 sm:p-6 md:p-8 md:ml-14">
//             <div className="mb-4 sm:mb-6">
//               <span className="text-gray-800 font-medium text-sm sm:text-base">
//                 Showing {filteredCompanies.length}{" "}
//                 {filteredCompanies.length === 1 ? "Result" : "Results"}
//               </span>
//             </div>

//             {isLoading ? (
//               renderLoadingSkeleton()
//             ) : (
//               <div className="max-w-7xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 lg:gap-10 ">
//                 {filteredCompanies.length > 0
//                   ? filteredCompanies.map((company) => (
//                       <CompanyCard
//                         key={company.companyId}
//                         company={company}
//                         onViewJobs={handleViewJobs}
//                       />
//                     ))
//                   : renderEmptyState()}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//       <Footer></Footer>
//     </div>
//   );
// };

// export default Company;






import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Search,
  MapPin,
  Building2,
  Globe,
  X,
  MapPinned,
  BriefcaseIcon,
  ArrowUpRight,
  Filter,
  Plus,
  Shield,
  Mail,
  ArrowRight,
} from "lucide-react";
import Navbar from "./shared/Navbar";
import Footer from "./Footer";
import TopCompanies from "./TopCompanies";
import { COMPANY_API_END_POINT } from "@/utils/constant";
import { useSelector } from "react-redux";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { motion } from "framer-motion";

// Card component for displaying company information
const CompanyCard = ({ company, onViewJobs }) => {
  return (
    <div
      className="bg-white rounded-xl border border-[#979696] hover:shadow-lg overflow-hidden flex items-center p-3 sm:p-4 cursor-pointer transition-all duration-300 hover:border-blue-300"
      onClick={() => onViewJobs(company.companyId)}
    >
      {/* Logo */}
      <div className="h-12 w-12 sm:h-14 sm:w-14 shrink-0 rounded-lg flex items-center justify-center bg-gray-50 mr-3 sm:mr-4">
        {company.logo ? (
          <img
            src={company.logo}
            alt={`${company.CompanyName} logo`}
            className="w-full h-full object-contain"
          />
        ) : (
          <Building2 className="w-5 h-5 sm:w-6 sm:h-6 text-gray-400" />
        )}
      </div>

      {/* Company Info */}
      <div className="flex-1 min-w-0">
        <h3 className="text-sm sm:text-base font-semibold text-gray-900 truncate">
          {company.CompanyName}
        </h3>
        <div className="flex items-center text-gray-600 mt-1">
          <MapPin className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 shrink-0" />
          <span className="text-xs sm:text-sm truncate">{company.location}</span>
        </div>
        {company.jobCount > 0 && (
          <div className="text-xs sm:text-sm text-gray-600 mt-1">
            {company.jobCount} {company.jobCount === 1 ? "Job posted" : "Jobs posted"}
          </div>
        )}
      </div>

      {/* Arrow Button */}
      <ArrowUpRight className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 shrink-0 ml-2" />
    </div>
  );
};


// Filter section component
const FilterSection = ({ filters, setFilters, showFilters }) => {
  if (!showFilters) return null;

  return (
    <div className="mt-4 flex flex-col sm:flex-row gap-3 sm:gap-4 max-w-4xl mx-auto">
      <div className="relative flex-1 min-w-0">
        <MapPinned className="absolute left-3 sm:left-4 top-3 sm:top-3.5 w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
        <input
          type="text"
          placeholder="Filter by location"
          className="w-full pl-10 sm:pl-12 pr-3 sm:pr-4 py-2.5 sm:py-3.5 border-2 rounded-lg sm:rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm sm:text-base"
          value={filters.location}
          onChange={(e) => setFilters({ ...filters, location: e.target.value })}
        />
      </div>

      <button
        className={`px-4 sm:px-6 py-2.5 sm:py-3.5 border-2 rounded-lg sm:rounded-xl font-medium transition-all duration-300 min-w-[140px] sm:min-w-[160px] text-sm sm:text-base ${
          filters.isHiring
            ? "bg-blue-600 border-blue-600 text-white hover:bg-blue-700"
            : "bg-white hover:bg-gray-50"
        }`}
        onClick={() =>
          setFilters((prev) => ({ ...prev, isHiring: !prev.isHiring }))
        }
      >
        Currently Hiring
      </button>
    </div>
  );
};

// Main component
const Company = () => {
  const userCompanies = useSelector((state) => state.company.allCompanies);
  const user = useSelector((state) => state.auth.user);

  // Candidates always see the browse view
  if (user?.role === "recruiter" || user?.role === "admin") {
    const hasCompanies = userCompanies && userCompanies.length > 0;
    if (!hasCompanies) {
      return <CompanyCreateJoinView />;
    }
  }

  return <CompanyBrowseView />;
};

// Company Browse View (existing functionality for users with companies)
const CompanyBrowseView = () => {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    location: "",
    search: "",
    isHiring: false,
  });

  // Fetch companies on mount
  useEffect(() => {
    fetchCompanies();
  }, []);

  // Filter companies when filters or companies change
  useEffect(() => {
    filterCompanies();
  }, [companies, filters]);

  // Fetch companies from API
  const fetchCompanies = async () => {
    try {
      const response = await fetch(
        `${COMPANY_API_END_POINT}/companyinfo`
      );
      const data = await response.json();
      if (data.status) {
        setCompanies(data.companies);
        setFilteredCompanies(data.companies);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Filter companies based on search criteria
  const filterCompanies = () => {
    let filtered = [...companies];

    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      filtered = filtered.filter(
        (company) =>
          company.CompanyName.toLowerCase().includes(searchTerm) ||
          company.description?.toLowerCase().includes(searchTerm)
      );
    }

    if (filters.location) {
      filtered = filtered.filter((company) =>
        company.location.toLowerCase().includes(filters.location.toLowerCase())
      );
    }

    if (filters.isHiring) {
      filtered = filtered.filter((company) => company.jobCount > 0);
    }

    setFilteredCompanies(filtered);
  };

  // Reset all filters
  const resetFilters = () => {
    setFilters({
      location: "",
      search: "",
      isHiring: false,
    });
  };

  // Handle navigation to jobs page
  const handleViewJobs = (companyId) => {
    navigate(`/jobs/${companyId}`);
  };

  // Render loading skeleton
  const renderLoadingSkeleton = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[...Array(6)].map((_, i) => (
        <div key={i} className="animate-pulse">
          <div className="h-72 bg-gray-100 rounded-2xl"></div>
        </div>
      ))}
    </div>
  );

  // Render empty state
  const renderEmptyState = () => (
    <div className="col-span-3 text-center py-16">
      <div className="mx-auto w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center mb-4">
        <Building2 className="w-12 h-12 text-gray-400" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">
        No companies found
      </h3>
      <p className="text-gray-600">Try adjusting your search criteria</p>
    </div>
  );

  return (
    <div className="min-h-screen ">
      <Navbar />
      <div className="mx-auto mt-20 sm:mt-20">
        <div className="mx-auto">
          {/* Header Section */}
          <div className="px-4 sm:px-8 md:px-36 py-6 sm:py-8 md:py-12 bg-[#DFECFF] w-full">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-left text-[#012760] mb-4 sm:mb-6 md:mb-10">
              Join your dream team.
            </h1>
            {/* Search and Filter Controls */}
            <div className="flex flex-col lg:flex-row gap-3 sm:gap-4 max-w-3xl mx-auto lg:ml-0">
              <div className="flex-1 relative">
                <Search className="absolute left-3 sm:left-4 top-3 sm:top-3.5 w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
                <input
                  type="text"
                  placeholder="Search companies or descriptions..."
                  className="w-full pl-10 sm:pl-12 pr-3 sm:pr-4 py-2.5 sm:py-3.5 border-2 rounded-lg sm:rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-gray-900 text-sm sm:text-base"
                  value={filters.search}
                  onChange={(e) =>
                    setFilters({ ...filters, search: e.target.value })
                  }
                />
              </div>

              <div className="flex items-center gap-2 sm:gap-3">
                <button
                  onClick={() => setShowFilters(!showFilters)}
                  className="px-3 sm:px-4 py-2.5 sm:py-3.5 border-2 rounded-lg sm:rounded-xl font-medium bg-[#012760] flex items-center gap-1.5 sm:gap-2 text-sm sm:text-base"
                >
                  <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
                  <span className="text-white">Filters</span>
                </button>

                {(filters.search || filters.location || filters.isHiring) && (
                  <button
                    onClick={resetFilters}
                    className="px-3 sm:px-4 py-2.5 sm:py-3.5 text-gray-700 hover:text-gray-900 flex items-center gap-1.5 sm:gap-2 text-sm sm:text-base"
                  >
                    <X className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span>Clear</span>
                  </button>
                )}
              </div>
            </div>

            {/* Filter Section */}
            <FilterSection
              filters={filters}
              setFilters={setFilters}
              showFilters={showFilters}
            />
          </div>

          <div>
            <TopCompanies />
          </div>
          <div className="bg-gray-300 h-px w-full"></div>

          {/* Content Section */}
          <div className="p-4 sm:p-6 md:p-8 md:ml-14">
            <div className="mb-4 sm:mb-6">
              <span className="text-gray-800 font-medium text-sm sm:text-base">
                Showing {filteredCompanies.length}{" "}
                {filteredCompanies.length === 1 ? "Result" : "Results"}
              </span>
            </div>

            {isLoading ? (
              renderLoadingSkeleton()
            ) : (
              <div className="max-w-7xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8 lg:gap-10 ">
                {filteredCompanies.length > 0
                  ? filteredCompanies.map((company) => (
                      <CompanyCard
                        key={company.companyId}
                        company={company}
                        onViewJobs={handleViewJobs}
                      />
                    ))
                  : renderEmptyState()}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

// Company Create/Join View (for users without companies)
const CompanyCreateJoinView = () => {
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [requestingId, setRequestingId] = useState(null);

  // OTP related states
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [otp, setOtp] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [adminEmail, setAdminEmail] = useState("");

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetch(`${COMPANY_API_END_POINT}/getall`, {
          method: "GET",
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch companies.");
        }

        const data = await response.json();
        setCompanies(data);
        setFilteredCompanies(data);
      } catch (error) {
        console.error("Error fetching companies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredCompanies(companies);
    } else {
      const filtered = companies.filter((company) =>
        company.companyName.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredCompanies(filtered);
    }
  }, [searchQuery, companies]);

  const handleRequestJoin = async (company) => {
    setRequestingId(company.companyId);
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userId = user ? user.email : null;

      if (!userId) {
        alert("User not logged in.");
        return;
      }

      const response = await fetch(`${COMPANY_API_END_POINT}/request-join`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ companyId: company.companyId, userId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to request join");
      }

      const data = await response.json();
      setAdminEmail(data.adminEmail);
      setCurrentCompany(company);
      setOtpDialogOpen(true);
    } catch (error) {
      console.error("Error requesting to join company:", error);
      alert(error.message || "Failed to request join");
    } finally {
      setRequestingId(null);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      alert("Please enter a valid 6-digit OTP");
      return;
    }

    setOtpLoading(true);
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const userId = user ? user.email : null;

      if (!userId || !currentCompany) {
        throw new Error("Missing user or company information");
      }

      const response = await fetch(`${COMPANY_API_END_POINT}/verify-join`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          companyId: currentCompany.companyId,
          userId,
          code: otp,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to verify OTP");
      }

      setOtpDialogOpen(false);
      navigate(`/admin/jobs`);
    } catch (error) {
      console.error("Error verifying OTP:", error);
      alert(error.message || "Failed to verify OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  const fadeIn = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="min-h-[80vh] flex flex-col max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 mt-20">
        <motion.div
          className="mb-10 text-center"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Company Directory
          </h1>
          <p className="mt-4 text-lg text-gray-500 max-w-2xl mx-auto">
            Join an existing company or set up your own
          </p>
          <div className="mt-6 h-1 w-20 bg-blue-600 mx-auto rounded-full"></div>
        </motion.div>

        {/* Search Bar */}
        <div className="relative mb-8 max-w-md mx-auto">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <Input
            type="text"
            placeholder="Search companies..."
            className="pl-10 w-full h-12 rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        {loading ? (
          <div className="flex-grow flex justify-center items-center">
            <div className="animate-spin rounded-full h-14 w-14 border-b-2 border-blue-500"></div>
          </div>
        ) : (
          <div className="flex-grow overflow-y-auto mb-8">
            {filteredCompanies.length === 0 ? (
              <motion.div
                className="text-center py-12 h-full flex flex-col justify-center"
                variants={fadeIn}
                initial="initial"
                animate="animate"
              >
                <div className="bg-gray-50 rounded-xl p-8 max-w-lg mx-auto shadow-sm border border-gray-200">
                  <Building2 className="w-16 h-16 text-gray-400 mx-auto mb-6" />
                  <h3 className="text-xl font-medium text-gray-800 mb-3">
                    No matching companies found
                  </h3>
                  <p className="text-gray-600 mb-8">
                    {searchQuery
                      ? "Try adjusting your search criteria"
                      : "There are no companies available to join at the moment"}
                  </p>

                  <div className="mt-2">
                    <Separator className="my-6" />
                    <p className="text-blue-700 font-medium text-lg mb-4">
                      Don't see your company?
                    </p>
                    <Button
                      onClick={() => navigate("/admin/companies/create")}
                      className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-8 py-3 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 group"
                      size="lg"
                    >
                      <Plus className="h-5 w-5 mr-2" />
                      Create Your Own Company
                      <ArrowRight className="h-5 w-5 ml-2 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-0 group-hover:translate-x-1" />
                    </Button>
                  </div>
                </div>
              </motion.div>
            ) : (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                  {filteredCompanies.map((company, index) => (
                    <motion.div
                      key={company.companyId}
                      className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 flex flex-col h-full"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.4, delay: index * 0.1 }}
                      whileHover={{ y: -5 }}
                    >
                      <div className="flex items-center mb-4">
                        <div className="bg-blue-50 rounded-lg h-14 w-14 flex items-center justify-center text-blue-700">
                          {company?.logo ? (
                            <img
                              src={company?.logo}
                              alt={`${company?.companyName || "Company"} logo`}
                              className="w-12 h-12 object-contain"
                            />
                          ) : (
                            <Building2 className="w-8 h-8 text-blue-500" />
                          )}
                        </div>
                        <h2 className="text-xl font-semibold ml-4 text-gray-800">
                          {company.companyName}
                        </h2>
                      </div>

                      <Separator className="my-4" />

                      {company.description && (
                        <p className="text-gray-600 text-sm mb-6 line-clamp-2 flex-grow">
                          {company.description}
                        </p>
                      )}

                      <Button
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-lg py-2 h-10"
                        onClick={() => handleRequestJoin(company)}
                        disabled={requestingId === company.companyId}
                      >
                        {requestingId === company.companyId ? (
                          <>
                            <span className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-r-transparent"></span>
                            Requesting...
                          </>
                        ) : (
                          <>
                            <Shield className="h-4 w-4 mr-2" />
                            Request to Join
                          </>
                        )}
                      </Button>
                    </motion.div>
                  ))}
                </div>

                {/* Bottom create company banner when companies exist */}
                <motion.div
                  className="mt-12 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 shadow-sm border border-blue-100 flex flex-col md:flex-row items-center justify-between"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                >
                  <div className="text-center md:text-left mb-4 md:mb-0">
                    <h3 className="text-xl font-semibold text-gray-800 mb-2">
                      Don't see your company?
                    </h3>
                    <p className="text-gray-600">
                      Create your own company profile in just a few steps
                    </p>
                  </div>
                  <Button
                    onClick={() => navigate("/admin/companies/create")}
                    className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white px-6 py-2 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 group"
                  >
                    <Plus className="h-5 w-5 mr-2" />
                    Create Your Company
                    <ArrowRight className="h-5 w-5 ml-2 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-0 group-hover:translate-x-1" />
                  </Button>
                </motion.div>
              </>
            )}
          </div>
        )}

        {/* OTP Verification Dialog */}
        <Dialog open={otpDialogOpen} onOpenChange={setOtpDialogOpen}>
          <DialogContent className="sm:max-w-md rounded-xl">
            <DialogHeader>
              <DialogTitle className="text-2xl font-bold text-center">
                OTP Verification
              </DialogTitle>
              <DialogDescription className="text-center">
                {currentCompany && (
                  <>
                    An OTP has been sent to the admin of{" "}
                    <strong className="text-blue-600">
                      {currentCompany.companyName}
                    </strong>
                    .
                  </>
                )}
                <div className="flex items-center mt-4 p-3 bg-amber-50 rounded-lg border border-amber-200">
                  <Mail className="h-5 w-5 text-amber-500 mr-3 flex-shrink-0" />
                  <span className="text-sm">
                    Contact admin at{" "}
                    <strong className="text-amber-700">{adminEmail}</strong> to
                    get the verification code
                  </span>
                </div>
              </DialogDescription>
            </DialogHeader>

            <div className="py-6">
              <div className="space-y-4">
                <Input
                  type="text"
                  placeholder="Enter 6-digit OTP"
                  maxLength={6}
                  className="text-center text-lg font-mono tracking-wider h-12 rounded-lg border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  value={otp}
                  onChange={(e) =>
                    setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
                  }
                />
              </div>
            </div>

            <DialogFooter className="flex flex-col sm:flex-row sm:justify-between gap-3">
              <Button
                type="button"
                variant="outline"
                onClick={() => setOtpDialogOpen(false)}
                className="w-full sm:w-auto rounded-lg border-gray-300"
              >
                Cancel
              </Button>
              <Button
                type="button"
                onClick={handleVerifyOtp}
                disabled={otpLoading || otp.length !== 6}
                className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 rounded-lg"
              >
                {otpLoading ? (
                  <>
                    <span className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-r-transparent"></span>
                    Verifying...
                  </>
                ) : (
                  "Verify & Join"
                )}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <Footer />
    </div>
  );
};

export default Company;
